/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/alt-text */
import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { getRoutePathById, withSiteMap } from '@bingads-webui-react/with-site-map';

import cardBackground from './card-bg.png';
import rightBackground from './right-bg.png';

const getStyles = () => ({
  navigateToFullProduct: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 4,
    position: 'relative',
    overflow: 'hidden',
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.12), 0px 2px 4px 0px rgba(0, 0, 0, 0.14)',
    padding: 24,
  },
  content: {
    zIndex: 1,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  cardBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${cardBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: '50% 50%',
    opacity: 0.2,
  },
  rightBackground: {
    position: 'absolute',
    right: -116,
    bottom: 0,
    width: 406,
    height: 366,
    backgroundImage: `url(${rightBackground})`,
    backgroundSize: 'contain',
  },
  title: {
    lineHeight: '36px',
    fontWeight: 600,
    fontSize: 28,
    margin: 0,
    paddingRight: 73,
  },
  description: {
    fontSize: 14,
    lineHeight: '20px',
    marginTop: 16,
    paddingRight: 150,
    flex: 1,
  },
});

interface INavigateToFullProductProps {
  onClick: () => void;
  className?: string;
}

export const NavigateToFullProduct: React.FC<INavigateToFullProductProps> = React.memo(({ className, onClick }) => {
  const classes = useDefaultStyles(getStyles);

  const i18n = useContext(I18nContext) as any;

  return (
    <div className={classNames('sdk-navigate-to-full-product', classes.navigateToFullProduct, className)}>
      <div className={classes.cardBackground} />
      <div className={classes.rightBackground} />
      <div className={classes.content}>
        <h3 className={classes.title}>{i18n.getString(_TL_('Optimize your business with Microsoft Advertising '))}</h3>
        <p className={classes.description}>{i18n.getString(_TL_('Explore a broad range of campaign types to help you achieve your goals (including Audience, Lodging, Search-Only, and Shopping campaigns).'))}</p>
        <div className="navigate-to-full-product-btn-wrapper">
          <Button onClick={onClick} appearance="primary">{i18n.getString(_TL_('Explore Microsoft Advertising'))}</Button>
        </div>
      </div>
    </div>
  );
});

NavigateToFullProduct.defaultProps = {
  className: '',
};

const getCardStyles = () => ({
  card: {
    position: 'absolute !important',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#fff',
  },
});

export const NavigateToFullProductCard = withSiteMap(({ siteMap }: { siteMap: object }) => {
  const classes = useDefaultStyles(getCardStyles);
  const { scope } = useContext(ScopeContext) as any;
  const {
    campaignId, aid, cid, uid,
  } = scope.values;

  const onNavigateToFullProductClick = useCallback(() => {
    const route = getRoutePathById(siteMap, 'overview');
    const search = `cid=${cid}&uid=${uid}&aid=${aid}&campaignId=${campaignId}`;
    const url = `${route}?${search}`;
    window.open(url);
  }, [aid, campaignId, cid, siteMap, uid]);

  return (
    <NavigateToFullProduct onClick={onNavigateToFullProductClick} className={classes.card} />
  );
});
